import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { countries, services, countryCodes } from "../data/popupFormData";

function PopupForm({ isOpen, onRequestClose }) {
  const [show, setShow] = useState(isOpen);

  const handleClose = () => {
    setShow(false);
    onRequestClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const form = event.target; // Get a reference to the form
    const formData = new FormData(form);

    // const fullName = form.elements.name.value;
    // const email = form.elements.email.value;
    // const countryCode = form.elements.mobile.value;
    // const mobileNumber = form.elements.mobileNumberInput.value;
    // const country = form.elements.country.value;
    // const service = form.elements.service.value;
    // const otherService = form.elements.otherService.value;

    // const fullMobileNumber = countryCode + mobileNumber;

    const scriptURL = "https://script.google.com/macros/s/AKfycbxSXPMB9vJxffgRJzu4OpLnDxQ1vU2CM55A29BL9XS0ky4Ju-Mvp0XkUtfuxwnx-aNV/exec";

    try {
      const response = await fetch(scriptURL, {
        method: "POST",
        mode: "cors",
        body: formData,
        
        // body: JSON.stringify({
        //   fullName,
        //   email,
        //   mobileNumber,
        //   fullMobileNumber,
        //   country,
        //   service,
        //   otherService,
        // }),
      });

      if (response.ok) {
        alert("Form submitted successfully!");
        handleClose();
      } else {
        throw new Error("Failed to submit form.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      alert("Failed to submit the form. Please try again later.");
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="custom-header">
          <Modal.Title>Inquiry Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} name="google-sheet">
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">
                Full Name:
              </label>
              <input
                type="text"
                className="form-control"
                id="fullName"
                name="fullName"
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email:
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="mobileNumber" className="form-label">
                Mobile Number:
              </label>
              <div className="mb-3 d-flex align-items-center">
                <span className="input-group-text me-6">
                  <select className="form-select" id="countryCodeSelect" name="countryCodeSelect">
                    {countryCodes.map((country, index) => (
                      <option key={index} value={country.code}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </select>
                </span>
                <input
                  type="tel"
                  className="form-control"
                  id="mobileNumberInput"
                  name="mobileNumberInput"
                  placeholder="Enter your mobile number"
                  required
                />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="country" className="form-label">
                Country:
              </label>
              <select className="form-select" id="country" name="country">
                {countries.map((country, index) => (
                  <option key={index} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="service" className="form-label">
                Select or Type Service:
              </label>
              <select className="form-select" id="service" name="service">
                {services.map((service, index) => (
                  <option key={index} value={service}>
                    {service}
                  </option>
                ))}
                <option value="Other">Others</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="otherService" className="form-label">
                Other Services:
              </label>
              <input
                type="text"
                className="form-control"
                id="otherService"
                name="otherService"
                placeholder="Enter other service"
              />
            </div>
            <input
                type="text"
                name="time"
                value={new Date().toString()} // Assuming you want to capture the current timestamp
                style={{ display: "none" }}
                readOnly
              />
            <div className="d-flex justify-content-end">
              <Button
                variant="secondary"
                onClick={handleClose}
                className="me-2 mx-4"
              >
                Close
              </Button>
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PopupForm;
